import React, { useEffect } from 'react';

import type { IProgressiveStyleSlots } from '../../helpers/applyProgressiveStyleSlots.utils';
import StoresProgressiveStyleGenerator from '../StoresProgressiveStyleGenerator/StoresProgressiveStyleGenerator';
import type { StoreAiPreviewVibe } from '../../constants/storeCheckoutAi.constants';

import './StoreReviewProgressiveModal.scss';

export interface IStoreReviewProgressiveModalProps {
  isOpen: boolean;
  presetStyleId: StoreAiPreviewVibe;
  isMobile?: boolean;
  isReadOnly?: boolean;
  singleImagePanel?: boolean;
  simulateBackSlotFailure?: boolean;
  onClose: () => void;
  onImagesCommitted: (slots: IProgressiveStyleSlots) => void;
}

const StoreReviewProgressiveModal: React.FC<IStoreReviewProgressiveModalProps> = ({
  isOpen,
  presetStyleId,
  isMobile = false,
  isReadOnly = false,
  singleImagePanel = false,
  simulateBackSlotFailure = false,
  onClose,
  onImagesCommitted,
}) => {
  useEffect(() => {
    if (!isOpen) {
      return undefined;
    }
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return (
    <div className="store-review-progressive-modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className={[
          'store-review-progressive-modal',
          singleImagePanel ? 'store-review-progressive-modal--single-image' : '',
        ]
          .filter(Boolean)
          .join(' ')}
        role="dialog"
        aria-modal
        aria-labelledby="store-review-progressive-modal-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className={[
            'store-review-progressive-modal__header',
            isMobile ? 'store-review-progressive-modal__header--with-back' : '',
          ]
            .filter(Boolean)
            .join(' ')}
        >
          {isMobile && (
            <button
              type="button"
              className="store-review-progressive-modal__back"
              aria-label="Back"
              onClick={onClose}
            >
              ‹
            </button>
          )}
          <span
            id="store-review-progressive-modal-title"
            className="store-review-progressive-modal__title"
          >
            AI Generated Images
          </span>
          {!isMobile && (
            <button
              type="button"
              className="store-review-progressive-modal__close"
              aria-label="Close"
              onClick={onClose}
            >
              <img
                src="/src/assets/svg/store-review/close.svg"
                alt=""
                width={22}
                height={22}
                aria-hidden
              />
            </button>
          )}
        </div>
        <div className="store-review-progressive-modal__body">
          <StoresProgressiveStyleGenerator
            layoutMode="directPanel"
            presetStyleId={presetStyleId}
            singleImagePanel={singleImagePanel}
            simulateBackSlotFailure={simulateBackSlotFailure}
            isReadOnly={isReadOnly}
            onImagesCommitted={onImagesCommitted}
            onDirectPanelDiscarded={onClose}
          />
        </div>
      </div>
    </div>
  );
};

StoreReviewProgressiveModal.displayName = 'StoreReviewProgressiveModal';

export default StoreReviewProgressiveModal;
